import { ArchiveMinusOutlineIcon } from './ArchiveMinusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id F0B3A03C-4591-4F17-8FD7-CD65BC990596
 * name archive-minus-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-minus-outline.svg
 * tags
 */
export const BoxMinusOutlineIcon = ArchiveMinusOutlineIcon;
export default BoxMinusOutlineIcon